var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-overlay',{staticStyle:{"z-index":"10000"},attrs:{"show":true}},[_c('div',{staticStyle:{"margin":"45% 0","height":"100vh"}},[_c('van-loading',{attrs:{"color":"#1989fa","size":"32","vertical":"","text-size":"16"}},[_vm._v("加载中")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }